export const BOOK_FILTER_FIELD = 'bookId';
